import React from "react";
import ConfirmationUserRequestMenu from "../components/menu/admin/ConfirmationUserRequestMenu";

const KonfirmasiEditUser = () => {
  return <ConfirmationUserRequestMenu />;
};
export default KonfirmasiEditUser;
